import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { User } from '../../../../../core/shared/models/user.model';
import {
  AddApplicationUser,
  DeleteApplicationUser,
} from '../../../../../core/shared/actions/application.user.actions';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
import { UserState } from '../../../../../core/shared/states/user.state';
import { NoWhiteSpaceValidator } from '../../../../../core/shared/validators/whitespace-validator';
import { ApplicationUser } from '../../../../../core/shared/models/application.user.model';
import { GetUsers } from '../../../../../core/shared/actions/user.actions';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { EmailDomainValidator } from '../../../../../core/shared/validators/email-validator';
@Component({
  selector: 'app-application-user-modal',
  templateUrl: './application-user-modal.component.html',
  styleUrls: ['./application-user-modal.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LoadingSpinnerComponent,
    MatSnackBarModule,
    MatFormField, MatLabel, MatInput, MatError, MatHint, MatIcon, MatButton, MatIconButton,
  ],
})
export class ApplicationUserModalComponent {
  @Input() public applicationName!: string;
  @Input() public formMode = 'New';
  @Input() public editUser = false;
  @Input() public user?: ApplicationUser;
  loading = true;
  private formSubscription: Subscription = new Subscription();
  entryForm!: FormGroup;
  error: string | undefined;
  userList: User[] = [];
  public readonly users: Observable<User[]>;
  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private store: Store,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.createForm();
    this.users = this.store.select(UserState.getUserList);
    this.store.dispatch(new GetUsers());
  }

  ngOnInit() {
    this.users.subscribe((data) => {
      this.userList = data;
      setTimeout(() => {
        this.loading = false;
      }, 350);
    });
    if (this.user) {
      this.entryForm.patchValue({
        application: this.user.application,
        email: this.user.email,
        receiveNotifications: this.user.receiveNotifications,
      });

      this.editUser = true;
      this.entryForm.get('email')?.disable();
    } else {
      this.editUser = false;
    }
  }
  public changeUser(e: any): void {
    const find = this.userList.find((x) => x?.Email === e.target.value);
  }
  // Handle Create  update button click
  onCreate_Update(): void {
    this.entryForm.controls['application'].setValue(this.applicationName);
    this.entryForm.controls['receiveNotifications'].setValue('true');

    const emailControlValue = this.entryForm.controls['email'].value;
    const emails = emailControlValue.includes(',')
      ? emailControlValue.split(',').map((email: string) => email.trim())
      : [emailControlValue.trim()];

    emails.forEach((email: string) => {
      const formValue = {
        ...this.entryForm.value,
        email: email,
      };

      this.formSubscription.add(
        this.store
          .dispatch(new AddApplicationUser(this.applicationName, formValue))
          .subscribe(
            (resp: any) => {
              this.showSnackBar(`User ${email} added successfully!`, false);
            },
            (error) => {
              this.showSnackBar(
                `An error occurred for ${email}: ${error.error.message}`,
                true
              );
            }
          )
      );
    });

    this.activeModal.close();
  }

  openConfirmModal(message: string) {
    // Open modal form component
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event) => {
      if (event == 'confirm') {
        this.onDelete();
      }
    });
  }
  // Handle Create button click

  // Handle Delete button click
  onDelete() {
    this.store
      .dispatch(
        new DeleteApplicationUser(
          this.applicationName,
          this.entryForm.controls['email'].value
        )
      )
      .subscribe(
        (resp: any) => {
          this.activeModal.close();
          this.showSnackBar('The User has been successfully deleted!!', false);
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      );
  }

  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      application: [''],
      email: new FormControl('', [
        Validators.required,
        NoWhiteSpaceValidator.cannotContainSpace,
        EmailDomainValidator('draexlmaier.com'),
      ]),
      receiveNotifications: [''],
    });
  }

  get f() {
    return this.entryForm.controls;
  }

  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 7000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }
  clearForm() {
    this.entryForm.reset();
  }
}
